{
  "sidebar": {
    "documents": "Documents",
    "sections": "Sections",
    "allDocs": "All documents",
    "recent": "Recent",
    "favorites": "Favorites",
    "shared": "Shared",
    "private": "Private",
    "folders": "Folders",
    "newFolder": "New folder"
  },
  "toolbar": {
    "search": "Search files...",
    "upload": "Upload",
    "newFolder": "Folder",
    "viewList": "List view",
    "viewGrid": "Grid view",
    "selected": "{{count}} selected",
    "clearSelection": "Clear",
    "moveSelected": "Move",
    "deleteSelected": "Delete",
    "sortBy": "Sort by",
    "sortByName": "Name",
    "sortBySize": "Size",
    "sortByDate": "Date",
    "sortByUploader": "Uploaded by",
    "sortAsc": "Ascending",
    "sortDesc": "Descending"
  },
  "list": {
    "empty": "No files in this project.",
    "emptyFolder": "This folder is empty.",
    "columns": {
      "name": "Name",
      "size": "Size",
      "uploadedBy": "Uploaded by",
      "date": "Upload date"
    }
  },
  "item": {
    "preview": "Preview",
    "download": "Download file",
    "delete": "Delete file",
    "move": "Move to folder",
    "rename": "Rename",
    "favorite": "Add to favorites",
    "unfavorite": "Remove from favorites",
    "makePrivate": "Make private",
    "makePublic": "Make public",
    "actions": "File actions",
    "moveDialog": {
      "title": "Move file",
      "folderLabel": "Destination folder",
      "root": "Project root"
    }
  },
  "file": {
    "deleteConfirmTitle": "Delete file?",
    "deleteConfirmDescription": "This action cannot be undone. The file will be permanently deleted.",
    "bulkDeleteConfirmTitle": "Delete {{count}} files?",
    "bulkDeleteConfirmDescription": "This action cannot be undone. All selected files will be permanently deleted.",
    "bulkDeletePartialWarning": "{{count}} file(s) could not be deleted.",
    "renameDialogTitle": "Rename file",
    "renameLabel": "File name"
  },
  "folder": {
    "createDialogTitle": "New folder",
    "renameDialogTitle": "Rename folder",
    "nameLabel": "Folder name",
    "parentLabel": "Parent folder (optional)",
    "open": "Open",
    "rename": "Rename",
    "delete": "Delete folder",
    "move": "Move folder",
    "actions": "Folder actions",
    "subfolderCount": "{{count}} subfolder",
    "subfolderCount_other": "{{count}} subfolders",
    "deleteConfirmTitle": "Delete folder?",
    "deleteConfirmDescription": "You can only delete empty folders. This action cannot be undone."
  },
  "form": {
    "validation": {
      "nameRequired": "Name is required"
    }
  },
  "fileType": {
    "image": "Image",
    "pdf": "PDF",
    "sheet": "Spreadsheet",
    "slides": "Slides",
    "document": "Document",
    "video": "Video",
    "audio": "Audio",
    "archive": "Archive",
    "code": "Code",
    "file": "File"
  },
  "preview": {
    "close": "Close preview",
    "previous": "Previous file",
    "next": "Next file",
    "unsupported": "Preview not available for this file type.",
    "loadError": "Could not load the file."
  },
  "apiErrors": {
    "uploadFailed": "Could not upload the file",
    "uploadFileTooLarge": "File exceeds the allowed size",
    "uploadInvalidType": "File type not allowed",
    "uploadForbidden": "You do not have permission to upload files",
    "deleteFailed": "Could not delete the file",
    "deleteNotFound": "File not found",
    "deleteForbidden": "You do not have permission to delete this file",
    "moveFailed": "Could not move the file",
    "moveFileNotFound": "File not found",
    "moveFolderNotFound": "Destination folder not found",
    "moveForbidden": "You do not have permission to move this file",
    "bulkDeleteFailed": "Could not delete the files",
    "bulkDeleteForbidden": "You do not have permission to delete these files",
    "renameFailed": "Could not rename the file",
    "renameNotFound": "File not found",
    "renameConflict": "A file with that name already exists",
    "renameForbidden": "You do not have permission to rename this file",
    "favoriteFailed": "Could not update favorite",
    "favoriteNotFound": "File not found",
    "favoriteForbidden": "You do not have permission to perform this action",
    "visibilityFailed": "Could not change visibility",
    "visibilityNotFound": "File not found",
    "visibilityForbidden": "You do not have permission to change visibility",
    "folderCreateFailed": "Could not create the folder",
    "folderNameTaken": "A folder with that name already exists",
    "folderCreateForbidden": "You do not have permission to create folders",
    "folderDeleteFailed": "Could not delete the folder",
    "folderNotEmpty": "The folder must be empty before it can be deleted",
    "folderNotFound": "Folder not found",
    "folderDeleteForbidden": "You do not have permission to delete this folder",
    "folderRenameFailed": "Could not rename the folder",
    "folderRenameForbidden": "You do not have permission to rename this folder",
    "folderMoveFailed": "Could not move the folder",
    "folderCircularReference": "You cannot move a folder into itself",
    "folderMoveForbidden": "You do not have permission to move this folder"
  }
}
